module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_08A.91104f1b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_08A.mp3
// module id = 119
// module chunks = 0